import router, { routes } from '@/router';
import { notFound } from './staticRouter/error';
import { welcome } from './staticRouter/welcome';
import { staticRouter } from './staticRouter/index';
import { isUrl } from '@/utils/is';
import { uniqueSlash } from '@/utils/urlUtils';

// 需要放在所有路由之后的路由
const endRoutes = [welcome, notFound];
const asyncRoutesPath = import.meta.glob('@/views/**/*.vue', { eager: false });
const asyncRoutes = Object.keys(asyncRoutesPath).reduce((routes, url) => {
  const path = url.replace(/\/src\/views\//, '');
  if (!/\/(login|components)\//.test(path)) {
    routes[path] = () => asyncRoutesPath[url]();
  }
  return routes;
}, {});
const newRouterCreater = asyncMenus => {
  const orignMenus = [...asyncMenus].filter(i => i.menuType !== 'PAGE');
  function buildTree(array) {
    const tree = [];
    const mapping = new Map();
    for (const node of array) {
      let lastNamePath = [];
      let parentRoute = null;
      let fullPath = '';
      const pathPrefix = lastNamePath.length > 0 ? lastNamePath[lastNamePath.length - 1] : '';
      let realRoutePath = node.url;
      if (node.openType !== 'EXTERNAL' || node.isRoute != '0') {
        if (isUrl(node.url)) {
          fullPath = node.url;
        } else {
          fullPath = node.url?.startsWith('/') ? node.url : `/${node.url}`;
          fullPath = node.url?.startsWith(pathPrefix) ? fullPath : pathPrefix + fullPath;
          fullPath = [...new Set(uniqueSlash(fullPath).split('/'))].join('/');
        }
        if (parentRoute) {
          if (fullPath.startsWith(parentRoute?.url)) {
            realRoutePath = fullPath.split(parentRoute.url)[1];
          } else if (!isUrl(parentRoute.url) && !isUrl(node.url)) {
            realRoutePath = node.url;
          }
        }
        realRoutePath = realRoutePath?.startsWith('/') ? realRoutePath.slice(1) : realRoutePath;
        realRoutePath = realRoutePath?.replace(/http(s)?:\/\//, '');
      }
      const route = {
        path: realRoutePath,
        name: node.componentName || realRoutePath,
        component: node.component,
        menuType: node.menuType,
        meta: {
          title: node.name,
          id: node.id,
          componentName: node.componentName,
          perms: node.perms,
          hidden: node.hidden,
          resourceOrder: node.resourceOrder,
          openType: node.openType, // INTERNAL/内部打开 EXTERNAL/外部打开 EMBEDDED/嵌入式打开
          icon: node.icon,
          type: node.type,
          namePath: lastNamePath.concat(fullPath),
          keepAlive: node.keepAlive,
          component: node.component,
          src: node.src,
          isRoute: node.isRoute,
        },
      };
      if (['MENU', 'NAVIGATOR'].includes(node.menuType)) {
        // 确保 Component 是一个返回组件对象的函数
        const Component =
          asyncRoutes[`${node.component}`] || (() => import('@/views/error/404.vue'));
        if (route.meta.openType == 'EMBEDDED') {
          route.component = () => import('@/layout/iframeBox');
        } else {
          route.component = Component;
        }
      }
      mapping.set(node.id, { ...route, children: [] });
    }

    for (const node of array) {
      const parent = mapping.get(node.parentId);
      if (parent) {
        parent.children.push(mapping.get(node.id));
      } else {
        tree.push(mapping.get(node.id));
      }
    }
    return tree;
  }
  const resolve = buildTree(orignMenus);
  return resolve;
};

export const generatorDynamicRouter = asyncMenus => {
  try {
    const routeList = newRouterCreater(asyncMenus);
    const layout = routes.find(item => item.name == 'layout');
    const layoutChildrenRouter = [...staticRouter, ...routeList, ...endRoutes];
    layout.children = layoutChildrenRouter;
    const removeRoute = router.addRoute(layout);

    const innerRoutes = router
      .getRoutes()
      .filter(
        item => !item.children.length && !['fullScreen', 'EXTERNAL'].includes(item.meta.openType)
      );
    const outRoutes = router
      .getRoutes()
      .filter(item => ['fullScreen', 'EXTERNAL'].includes(item.meta.openType));
    removeRoute();
    layout.children = [...innerRoutes];
    router.addRoute(layout);
    outRoutes.forEach(item => {
      router.addRoute(item);
    });
    return Promise.resolve({
      menus: layoutChildrenRouter,
      routes: layout.children,
    });
  } catch (error) {
    return Promise.reject(`生成路由时出错: ${error}`);
  }
};
